import { useAuth } from "@clerk/clerk-react";

export interface SessionState {
  isReady: boolean;
  isAuthenticated: boolean;
}

export function useSession(): SessionState {
  const { isLoaded, isSignedIn } = useAuth();

  return {
    isReady: isLoaded,
    isAuthenticated: !!isSignedIn,
  };
}
